import { RefObject, useEffect, useState } from 'react';

export const useBackToTop = (headerRef: RefObject<HTMLElement>) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const rect = headerRef.current?.getBoundingClientRect();
      if (!rect) return;

      setShowButton(rect.bottom < 0);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [headerRef]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return { showButton, scrollToTop };
};